import salesSummaryComponentUrl from './salesSummaryComponent.html';
export default {
  templateUrl: salesSummaryComponentUrl,
  controllerAs: 'ctrl',
  bindings: {
    projectedSales: '=',
    totals: '=',
    mode: '@?',
    days: '<',
    inactive: '<?',
    locationId: '@',
    onToggleFocus: '&',
    onChange: '&?',
    calculateLaborPercentage: '&',
  },
};
